import React from "react";
import { Component } from "react";
import CollegeContainer from "../Container/CollegeContainer";
import TimetableForm from "./TimetableForm";
import TimetableFormMobile from "./TimetableFormMobile";
import VerticalTabs from "../../Components/Tabs/VerticalTabs";
import { PORT } from "../../config";
import axios from "axios/index";

import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Pagination from "../../Components/PaginationDot/Pagination";
import AddCircleIcon from '@material-ui/icons/AddCircle';

import { connect } from "react-redux";
import { createClass } from "../../redux/college/college.actions";
import { notify } from "react-notify-toast";
import { API } from "../../API";
import { permIndices } from "../../Permissions"

// Disable outline for focused item
import "./app.css"

class CollegeTimetable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // classes: [],
      // customer: '',
      // campuses: [],
      tabPairs: [],
      width: 0,
      index: 0,
      duplicatedTimetable: null,
      bookingCount: []
    }
    this.child = React.createRef();
  }

  tabs = this.props.user.role === 'customer' ? [
    {
      text: this.props.user?.is_childcare_centre ? "Centre" : "Campus",
      pathname: "/Campus",
    },
    {
      text: "Personnel",
      pathname: "/Personnel",
    },
    {
      text: this.props.user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
      active: true,
    },
    {
      text: "Finance Settings",
      pathname: "/FinanceSetting",
    },
    {
      text: "Budget Settings",
      pathname: "/BudgetSetting",
    },
  ] : [{
    text: this.props.user?.is_childcare_centre ? "Centre" :"Campus",
    pathname: "/Campus",
  },
    {
      text: this.props.user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
      active: true,
    },
  ];

  clickTab = (key) => {
    this.child.current.swapTabWithConfirm(key);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  }

  updateTabPairs = () => {
    // console.log("updating tabs")
    let { classes } = this.props;
    if (this.props.user.customer_id === "66626457ceae3e5da17a15ba") { // stleonards@heischools.com.au customer
      classes = classes.filter(classItem => classItem.campus_id === "66628e6aceae3e5da17a8727")
    }

    var tabPairs = []
    for (var i = 0; i < classes.length; i++) {
      const tabPair = {
        tabKey: classes[i]._id,
        rn: classes[i].reference_name,
        expired_time: classes[i].expired_time,
        campus_id: classes[i].campus_id
      }
      tabPairs.push(tabPair)
    }
    /*
    let tabPairs = classes.map(classObj => {
      return {
        tabKey: classObj._id,
        rn: classObj.reference_name,
      }
    })
     */

    // console.log(tabPairs)
    this.setState({
      tabPairs: tabPairs,
    })
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.classes) !== JSON.stringify(this.props.classes)) {
      // console.log(prevProps.classes, this.props.classes)
      this.updateTabPairs();
    }
  }

  componentDidMount = () => {
    API.countBookingForClassList(this.props.classes.map(classItem => classItem._id))
      .then(result => {
        this.setState({
          bookingCount: result?.data?.data || []
        })
      })
      .catch(error => {
        console.log("error on count: ", error)
      })

      this.setState({
        index: 1,
      }, () => {
        this.setState({
          index: 0,
        })
      })
  
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
  
      this.updateTabPairs();
    
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  styles = {
    tabs: {
      background: '#fff',
    },
    slide: {
      padding: 15,
      minHeight: 100,
    },
    slide1: {
      backgroundColor: '#FFFFFF',
    },
  };

  handleChangeIndex = (index) => {
    this.setState({
      index: index,
    });
  }

  handleChange = (event, value) => {
    this.setState({
      index: value,
    });
  };

  addNewClass = () => {
    if (!this.props.campuses.length) {
      notify.show('Please complete Campus screen first before this screen')
    } else {
      API.createClass({
        campus_id: this.props.campuses[0]._id,
        inst_shortname: this.props.institution.inst_shortname,
        inst_id: this.props.institution._id,
      }).then((res) => {
        // var temp = this.props.classes
        // temp.push(res.data)
        // this.setState({
        //   classes: temp,
        // })
        this.props.createClass(res.data);
        // const msg = "Class created successfully";
        // notify.show(msg);
      }).catch((err) => {
        console.log(err.response)
        notify.show("Error creating class.")
      })
    }
  }

  duplicateClass = (e) => {
    e.preventDefault()
    this.clickTab('addNew')
    // this.updateTabPairs()
    this.setState({ duplicatedTimetable: {...this.child.current.state, is_duplicate: true} }, () => {
      setTimeout(() => {this.child.current.handleSubmit(e)}, 2000)
    })
  }

  render() {
    let tabPairsFilter = this.state.tabPairs
    console.log('tabPairsFilter', tabPairsFilter)
    if(this.props.user.role !== 'customer') {
      tabPairsFilter = this.state.tabPairs.filter(ele => this.props.user.campuses.includes(ele.campus_id))
    }
    return (
      <div>
        {(this.state.width > 480) ? (
          <CollegeContainer
            header={this.props.user?.is_childcare_centre ? "Set up shift" : "Set up class"}
            user={this.props.user}
            tabs={this.tabs}
            tabPairs={tabPairsFilter}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('timetable-Index') != null) ? parseInt(localStorage.getItem('timetable-Index')) : 0}
            viewbookings={this.props.viewbookings}
            addable={this.props.editclass}
          // buttons={buttons}
          >
            <div hidden={this.props.classes.length == 0}>
              <TimetableForm
                classes={this.props.classes.map(ele => {
                  return {
                    ...ele,
                    expired_time: ele.expired_time || ''
                  }
                }).filter(ele => {
                  if(this.props.user.role !== 'customer') {
                    return this.props.user.campuses.includes(ele.campus_id)
                  } else if (this.props.user.customer_id === "66626457ceae3e5da17a15ba") { // stleonards@heischools.com.au customer
                    return ele.campus_id === "66628e6aceae3e5da17a8727"
                  } else {
                    return true
                  }
                })}
                ref={this.child}
                // handleSubmit={this.handleSubmit}
                //  handleRadioChange={this.handleRadioChange}
                handleViewElicosGE={this.handleViewElicosGE}
                handleViewElicosEP={this.handleViewElicosEP}
                handleViewElicosO={this.handleViewElicosO}
                handleViewVetE={this.handleViewVetE}
                duplicateClass={this.duplicateClass}
                duplicatedTimetable={this.state.duplicatedTimetable}
                campuses={this.props.campuses}
                institution={this.props.institution}
                user={this.props.user}
                updateTabPairs={this.updateTabPairs}
                editclass={this.props.editclass}
                personnels={this.props.personnel}
                bookingCount={this.state.bookingCount}
              />
            </div>
            <div hidden={this.props.classes.length != 0} className="absolute-align-items-center">
              <p>Currently there is no data available. Click ADD NEW to create an entry.</p>
            </div>
          </CollegeContainer>
        ) : (
          <CollegeContainer
            header={this.props.user?.is_childcare_centre ? "Set up shift" : "Set up class"}
            tabs={this.tabs}
            tabPairs={tabPairsFilter}
            onAdd={this.onAdd}
            onClickTab={this.clickTab}
            initialIndex={(localStorage.getItem('timetable-Index') != null) ? parseInt(localStorage.getItem('timetable-Index')) : 0}
            viewbookings={this.props.viewbookings}
            addable={this.props.editclass}
          // buttons={buttons}
          >
            <Tabs value={this.state.index}
              fullWidth
              onChange={this.handleChange}
              variant="scrollable"
              TabIndicatorProps={{
                style: { background: "#34F1C8", color: "#34F1C8" }
              }}
              scrollButtons="on">
              {this.props.classes.map((classe) => (
                <Tab label={<span style={this.props.classes[this.state.index] == classe ? ({ color: "#34F1C8" }) : ({ color: "gray" })}>{classe.reference_name}</span>} />
              ))}
              {this.props.editclass && <Tab label={<span style={{ color: "#3BB4D8" }}>AddNew</span>} icon={<AddCircleIcon style={{ color: "#3BB4D8" }} />} onClick={this.addNewClass} />}
            </Tabs>
            <SwipeableViews index={this.state.index} onChangeIndex={this.handleChangeIndex} enableMouseEvents>
              {this.props.classes.map((classe) => (
                <div id={classe._id + "TFMDiv"} style={Object.assign({}, this.styles.slide, this.styles.slide1)}>
                  <TimetableFormMobile
                    id={classe._id + "TimetableFormMobile"}
                    mobileCla={classe}
                    campuses={this.props.campuses}
                    editclass={this.props.editclass}
                    user={this.props.user}
                  />
                </div>
              ))}
            </SwipeableViews>

          </CollegeContainer>
        )}
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    campuses: state.college.campuses,
    classes: state.college.classes,
    institution: state.college.institution,
    viewbookings: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.vi_book) : 1,
    editclass: (state.college.user.permissions) ? state.college.user.permissions & (1 << permIndices.ed_cla) : 1,
    personnel: state.college.personnel
  }
}

const mapDispatchToProps = (dispatch) => ({
  createClass: (newClass) => dispatch(createClass(newClass)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CollegeTimetable);
